module.exports = __webpack_public_path__ + "static/media/04-press.a7d17e29.png";